export const GET_AIRLIEN_INFO_STATE = {
  success: 'get airline info success',
  faild: 'get airline info faild',
};
